import { Avatar, Button, Dialog, DialogTitle, Tooltip } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import { Colors } from "components/Events";
import { ParcelStatus, UserCreatedBy } from "generated/graphql";
import React from "react";
import styled from "styled-components";
import StatusInfo from "ui/StatusInfo";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: 260,
      height: 80,
      borderRadius: 6,
      border: "solid 1px rgba(118, 118, 118, 0.33)",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#fff",
      padding: "0.3rem 0.3rem 0.3rem 0.3rem",
    },
    first: {
      flex: 1,
      display: "flex",
    },
    second: { flex: 1, color: "#707070" },
    text: {
      fontSize: 12,
      padding: 10,
      overflow: "scroll",
    },

    fleche: {
      backgroundColor: "#525ffb",
      flex: 1,
      display: "flex",
      marginBottom: "auto",
      fontSize: "0.7rem",
      padding: 5,
      color: "#fff",
    },
    signatureContainer: {
      padding: 20,
      border: "solid 1px gray",
      width: theme.spacing(15),
      height: theme.spacing(15),
      backgroundColor: "#eee",
    },
    signature: {
      position: "absolute",
      right: 7,
      bottom: 15,
      borderRadius: 3,
      fontSize: 11,
      color: "#389ebf",
      fontFamily: "Avenir",
      backgroundColor: "transparent",
      border: "solid 1px #389ebf",
      "&:focus": {
        outline: 0,
      },
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#389ebf",
        color: "white",
      },
    },
    button: {
      position: "absolute",
      right: 7,
      top: 18,
    },
  })
);

const FlecheDiv = styled.div.attrs((props) => ({
  statusColor: "",
  statusTextColor: "",
  ...props,
}))`
  & {
    position: relative;
    margin-left: 15px;
    color: ${(props) => props.statusTextColor};
    background: ${(props) => props.statusColor};
    &:after {
      content: "";
      height: 0px;
      width: 0px;
      border-top: 12px solid transparent;
      border-bottom: 12px solid transparent;
      border-right: 12px solid ${(props) => props.statusColor};
      position: absolute;
      left: -12px;
      top: 0px;
    }
  }
`;
export interface EventItemProps {
  status: string;
  username: string;
  description: string;
  userColor?: string;
  userTextColor?: string;
  statusColor?: string;
  statusTextColor?: string;
  height?: number;
  width?: number;
  user?: UserCreatedBy | null;
  signature?: string;
  color: Colors;
}
export const EventItem = ({
  status,
  username,
  description,
  statusColor = "#525ffb",
  statusTextColor = "#fff",
  user = null,
  signature,
  color,
}: EventItemProps) => {
  const styles = useStyles();
  const [visibleDialog, setVisibleDialog] = React.useState(false);
  const handleClose = () => {
    setVisibleDialog(false);
  };
  const handleOpenDialog = () => {
    setVisibleDialog(true);
  };
  return (
    <div className={styles.root}>
      <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={visibleDialog}>
        <Button className={styles.button} variant="text" onClick={handleClose}>
          <CloseIcon />
        </Button>
        <DialogTitle>
          <p style={{ fontFamily: "Avenir" }}>Signature</p>{" "}
        </DialogTitle>

        <div style={{ padding: 30 }}>
          <Avatar className={styles.signatureContainer} variant="rounded" alt="Signature" src={signature} />
        </div>
      </Dialog>
      <div className={styles.first}>
        <StatusInfo
          width="120px"
          color={color?.text}
          background={color?.background}
          border={color?.border}
          status={status?.replace(/_/g, " ")}
        />
        <Tooltip title={`${user?.first_name} ${user?.last_name}, ${user?.phone_number}`}>
          <FlecheDiv className={styles.fleche} statusColor={statusColor} statusTextColor={statusTextColor}>
            {username !== null ? username : "No User"}
          </FlecheDiv>
        </Tooltip>
      </div>
      <Tooltip title={description} className={styles.second}>
        <div className={styles.second}>
          <div className={styles.text}>{description?.substring(0, 60)}...</div>
        </div>
      </Tooltip>

      {status === ParcelStatus.Successful && signature && (
        <button type="button" className={styles.signature} onClick={handleOpenDialog}>
          Signed
        </button>
      )}
    </div>
  );
};
